import { getAudioContext, scaledGain } from './audioState';

/**
 * The general notification beep — a two-tone chime.
 *
 * Uses the shared AudioContext rather than constructing one per call. The old
 * version created a new `AudioContext` on every notification, which browsers
 * cap (typically ~6 concurrent); a busy afternoon would exhaust the limit and
 * every subsequent beep would fail silently.
 */
export const playNotificationSound = () => {
  const ctx = getAudioContext();
  if (!ctx) return;

  const playTone = (frequency: number, startTime: number, duration: number) => {
    const oscillator = ctx.createOscillator();
    const gainNode = ctx.createGain();

    oscillator.connect(gainNode);
    gainNode.connect(ctx.destination);

    oscillator.frequency.value = frequency;
    oscillator.type = 'sine';

    // Envelope for smooth sound. `exponentialRampToValueAtTime` cannot reach
    // zero, hence the small floor.
    const peak = scaledGain(0.3);
    gainNode.gain.setValueAtTime(0, startTime);
    gainNode.gain.linearRampToValueAtTime(peak, startTime + 0.01);
    gainNode.gain.exponentialRampToValueAtTime(
      Math.max(peak * 0.03, 0.0001),
      startTime + duration,
    );

    oscillator.start(startTime);
    oscillator.stop(startTime + duration);
  };

  const now = ctx.currentTime;
  playTone(800, now, 0.1);
  playTone(1000, now + 0.12, 0.1);
};
